import _ from 'underscore';

import {assert} from 'Asserts';
import {CidIdMap} from 'notebook/notes/NoteConstants';

// Register ids in cid map, and remove id
export function addCid<T extends {id?: string | number; cid?: string}>(
  item: T,
  prefix: string,
  cidIdMap: CidIdMap
): void {
  assert(item.cid == null, 'Trying to add a cid to an item that already has one');
  item.cid = _.uniqueId(prefix);
  if (item.id != null) {
    cidIdMap[item.cid] = item.id;
  } else {
    delete cidIdMap[item.cid];
  }
  delete item.id;
}
